var _defs, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 60.66 48.31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".message-message-1-1{fill:#353535;}.message-message-1-2{fill:url(#radial-gradient);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -284.84,
    cy: 466.12,
    r: 1,
    gradientTransform: "matrix(152.1, 115.67, 144.14, -189.54, -23871.83, 121284.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee2338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b01f24"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "message-message-1-1",
    d: "M54.34,14.2H52.8V31.06c0,2.62-1.52,5-4.59,5h-30v.8c0,2.32,2.64,4.66,5.35,4.66h23l8.78,5.16L54,41.52h.34c2.71,0,3.93-2.34,3.93-4.66V18.2C58.27,15.88,57.05,14.2,54.34,14.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "message-message-1-2",
    d: "M43.73,2.49H8.87c-3.07,0-6.6,2.72-6.6,5.35V29c0,2.42,3,4.17,5.86,4.43L6.26,40.49l12-7h25.5c3.07,0,5.9-1.86,5.9-4.48V7.84C49.63,5.21,46.8,2.49,43.73,2.49ZM14.19,20.32a3.15,3.15,0,1,1,3.15-3.15A3.15,3.15,0,0,1,14.19,20.32Zm11.76,0a3.15,3.15,0,1,1,3.15-3.15A3.15,3.15,0,0,1,26,20.32Zm11.76,0a3.15,3.15,0,1,1,3.15-3.15A3.15,3.15,0,0,1,37.71,20.32Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Message.f59c643c.svg";
export { ForwardRef as ReactComponent };